export default "__VITE_ASSET__DwH9n_3h__"